<template lang="pug">
.results-list.mt-4
  v-data-table(
    :headers="headers"
    :items="list"
    item-key="ID"
    hide-default-footer
    :disable-sort="false"
    :server-items-length="list.length"
    :loading="loading"
    multi-sort=false
    :sort-by="sortModel.by"
    :sort-desc="sortModel.desc"
    @update:sort-by="$emit('update:sort-by', $event)"
    @update:sort-desc="$emit('update:sort-desc', $event)"
    class="res-table"
  )
    template(v-slot:item="{item, index}")
      list-item(:item="item" :index="index" :key="item.ID" :primaryPagination="primaryPagination")
    template(v-slot:footer="{options}")
      .pagination(v-if="pagination")
          div.pagination__more
            v-btn(
              color="primary" 
              text 
              class="mb-3 mt-3" 
              @click="onLoadMoreClick" 
              :loading="loading" 
              v-if="pagination.next"
              data-test="res-pagination-btn"
            ) load more
          div.pagination__actions
            v-pagination(
                @input="paginationChange"
                :disabled="loading"
                :length="pagination.totalPages" 
                v-model="pagination.page" 
                :total-visible="8")
      
</template>

<script>
import { RESERVED_EXAM } from '../core/models/resultModel'
import { RESERVED_EXAM_CANDIDATE } from '../core/models/resultCandidateModel'
import { RESULT } from '../core/models/resultReservedExam'
import paginationMixin from '@/mixins/pagination.mixin'
import ResultSortModel from "../core/models/resultSortModel"

export default {
  mixins: [paginationMixin],
  props: {
    list: {
      type: Array,
      required: true
    },
    loading: Boolean,
    pagination: Object,
    primaryPagination: Object,
    sortModel: Object
  },

  data: () => ({
    headers: [
      { text: '№', value: '#ss', sortable: false, align: 'center' },
      { text: 'Reserved info', value: 'reserved', sortable: true, align: 'center' },
      { text: 'Absentie', value: RESERVED_EXAM.HAS_COME_TO_COURSE, align: 'center', sortable: true },
      { text: 'Name', value: 'candidate__name', sortable: true, align: 'center'},
      { text: 'Number', value: RESERVED_EXAM.RESERVATION_CODE, align: 'center', sortable: false  },
      { text: 'Result', value: 'result__results', align: 'center', sortable: true},
      { text: 'Status', value: RESULT.STATUS, sortable: false, align: 'center' },
      { text: 'App id', value: RESERVED_EXAM.APPLICATION_ID, align: 'center', sortable: false},
      { text: 'Type', value: RESERVED_EXAM.IS_MIJN_RESERVATION, align: 'center', sortable: true },
      { text: 'Category', value: 'product_name', align: 'center', sortable: true},
      { text: 'Notes', value: 'notes', align: 'center', sortable: false},
    ],
    
    
  }),

  methods: {
    initSortModel() {
      this.sortModel = new ResultSortModel(this.$route.query)
    },
  },

  components: {
    listItem: () => import ('./ResultsListItem.vue')
  }
}
</script>

<style lang="scss" scoped>

.results-list::v-deep {
  .app-table tr td:first-child{
    padding-left: 4px;
  }
  .app-table th {
    border-right: 1px solid $border-color;
    &:last-child {
      border-right: unset;
    }
  }
  .app-table tr td {
    border-right: 1px solid $border-color;
    border-bottom :1px solid $border-color;
  }
}


.table-dates {
  width: 170px;
  line-height: 1.3;
}

.table-date {
  font-size: 10px;
  &_main {
    font-weight: bold;
  }
  &_additional {
    color: $label-color;
    font-weight: 500;
  }
}
</style>